
export default (score) => score > 74 ? 'bg-[#6c3]' : score > 49 ? 'bg-[#fc3]' : 'bg-[#f00]';